import Applovin from '~/assets/applovin.svg'
import FacebookLogo from '~/assets/facebook.svg'
import IronsourceLogo from '~/assets/ironsource.svg'
import MintegralLogo from '~/assets/mintegral.svg'
import TiktokLogo from '~/assets/tiktok.svg'

export const networkOptions: IOption[] = [
  {
    label: 'Facebook',
    value: 'facebook',
  },
  {
    label: 'Tiktok',
    value: 'tiktok',
  },
  {
    label: 'Iron source',
    value: 'ironsource',
  },
  {
    label: 'Mintegral',
    value: 'mintegral',
  },
  {
    label: 'Applovin',
    value: 'applovin',
  },
]

export const NETWORK_LOGO: Record<string, string> = {
  applovin: Applovin,
  facebook: FacebookLogo,
  ironsource: IronsourceLogo,
  mintegral: MintegralLogo,
  tiktok: TiktokLogo,
}

export const RECOMMENDATIONS: Record<string, string> = {
  decrease_bid_10_perc: 'Decrease Bid: -10%',
  decrease_bid_15_perc: 'Decrease Bid: -15%',
  decrease_budget_10_perc: 'Decrease Budget: -10%',
  decrease_budget_20_perc: 'Decrease Budget: -20%',
  decrease_target_10_perc: 'Decrease Target: -10%',
  increase_bid_15_perc: 'Increase Bid: +15%',
  increase_budget_10_perc: 'Increase Budget: +10%',
  increase_budget_20_perc: 'Increase Budget: +20%',
  increase_target_10_perc: 'Increase Target: +10%',
  increase_target_15_perc: 'Increase Target: +15%',
}

export const getWarning = (warning: string): string => {
  switch (warning) {
    case 'potential_under_estimation':
      return 'Potential under estimation'
    case 'potential_over_estimation':
      return 'Potential over estimation'
    default:
      return warning
  }
}
